import algoliasearch from 'algoliasearch';
import React from 'react';
import { MemberSearchResultList } from './member_search_result_list';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';

const createReactClass = require('create-react-class');

const AlgoliaMemberSearchBox = createReactClass({
  componentDidMount() {
    this.algoliaRef = algoliasearch(StringConstantsMixin.constants.ALGOLIA.ACCOUNT, StringConstantsMixin.constants.ALGOLIA.API_KEY);
    this.algoliaIndex = this.algoliaRef.initIndex('alltrails_users');
    this.firstInput = false;
    $(document).on('click', this.handleClick);
    $(document).on('keydown', this.handleKeyDown);
  },
  getInitialState() {
    return { results: [], currentSelection: -1, searchTerm: '', shouldShow: false };
  },
  handleSubmit() {
    if (this.state.currentSelection >= 0 && this.state.currentSelection < this.state.results.length) {
      const { slug } = this.state.results[this.state.currentSelection];
      _gaq.push(['_trackEvent', 'Member Search', this.state.searchTerm, slug, this.state.currentSelection]);
      window.location.href = LanguageSupportUtil.wrapUrlSafe(`/members/${slug}?ref=search`, this.props.languageRegionCode);
      return false;
    }
    _gaq.push(['_trackEvent', 'Member Search', this.state.searchTerm, 'Search Submit']);
    return true;
  },
  handleSearch() {
    const searchTerm = this.refs.memberSearchInput.value;
    this.setState({ searchTerm });

    if (searchTerm.length == 0) {
      this.setState({ results: [] });
      return;
    }
    let numResults = 10;
    if (this.props.homePage) numResults = 8;
    this.algoliaIndex.search(
      searchTerm,
      {
        hitsPerPage: numResults,
        distinct: 1,
        getRankingInfo: 1,
        allowTyposOnNumericTokens: 0
      },
      this.handleSearchResults
    );
  },
  handleInput(e) {
    if (e.keyCode == 38 || e.keyCode == 40) {
      e.preventDefault();
      return false;
    }
    const term = this.refs.memberSearchInput.value;
    if (this.state.searchTerm != term) this.handleSearch();
    if (term != '') {
      this.setState({ shouldShow: true });
      if (!this.firstInput) {
        this.firstInput = true;
        _gaq.push(['_trackEvent', 'Header Middle', 'Search Box', 'Search Box']);
      }
    } else this.setState({ shouldShow: false });
    return true;
  },
  handleSearchResults(err, content) {
    if (err) {
      console.err(err);
      return;
    }
    this.setState({ results: content.hits, currentSelection: 0 });
  },
  handleFocus() {
    if (this.refs.memberSearchInput.value != '') this.setState({ shouldShow: true });
  },
  handleKeyDown(e) {
    if (this.state.shouldShow && e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 13) {
      this.setState({ currentSelection: 0 });
      return true;
    }
    if (!this.state.shouldShow || (e.keyCode !== 38 && e.keyCode !== 40)) {
      return true;
    }
    if (this.state.shouldShow && e.keyCode === 38) {
      if (this.state.currentSelection == 0 || this.state.currentSelection === -1) {
        this.refs.searchInput.focus();
      }
      if (this.state.currentSelection >= 0) {
        this.setState({ currentSelection: this.state.currentSelection - 1 });
      }
    } else if (this.state.shouldShow && e.keyCode == 40 && this.state.currentSelection < this.state.results.length) {
      this.setState({ currentSelection: this.state.currentSelection + 1 });
    }
    e.preventDefault();
    return false;
  },
  handleClick(e) {
    if ($(e.target).parents('#algolia-member-search').length == 0 && this.state.shouldShow == true)
      this.setState({ shouldShow: false, currentSelection: 0 });
  },
  handleHover(i) {
    this.setState({ currentSelection: i });
  },
  render() {
    let classes = '';
    if (!this.state.shouldShow) {
      classes = 'hidden';
    }

    let searchBox = '';
    if (this.props.homePage) {
      searchBox = 'searchbox-big ';
    }

    if (this.props.mobileBrowser) {
      searchBox += 'mobile-browser-search';
    }

    const searchBtn = (
      <div className="search-btn-holder">
        <input type="submit" value="" className="search-icon-svg" onClick={this.handleSubmit} />
      </div>
    );
    return (
      <form className="floatright" id="algolia-member-search" onFocus={this.handleFocus} action="/search" method="get" onSubmit={this.handleSubmit}>
        <div id="member-search-box" className={searchBox}>
          <input
            ref="memberSearchInput"
            id="member-search"
            autoCorrect="off"
            spellCheck="false"
            autoComplete="off"
            type="text"
            name="q"
            placeholder={StringConstantsMixin.strings.SEARCH.ENTER_MEMBERS_NAME}
            onKeyUp={this.handleInput}
          />
          <div className={classes}>
            <MemberSearchResultList
              languageRegionCode={this.props.languageRegionCode}
              currentSelection={this.state.currentSelection}
              handleResultHover={this.handleHover}
              items={this.state.results}
              term={this.state.searchTerm}
            />
          </div>
        </div>
        {searchBtn}
      </form>
    );
  }
});

export { AlgoliaMemberSearchBox };
